import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import WgptAutomations from './Index.vue';
import WgptAutomationEditor from './edit/AutomationEditorPage.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/wgpt-automations'),
      meta: {
        featureFlag: FEATURE_FLAGS.WGPT_AUTOMATIONS,
        permissions: ['administrator'],
      },
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'wgpt_automations',
          redirect: 'list',
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'list',
          name: 'wgpt_automations_list',
          component: WgptAutomations,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL(
        'accounts/:accountId/settings/wgpt-automations/:automationId/edit'
      ),
      name: 'wgpt_automations_edit',
      meta: {
        featureFlag: FEATURE_FLAGS.WGPT_AUTOMATIONS,
        permissions: ['administrator'],
      },
      component: WgptAutomationEditor,
    },
  ],
};
